import { OccurrenceStepEnum } from "../../../enums/occurrenceStep";
import { Occurrence } from "../../../models/occurrence";

export const mustSelectTasForStage = (
  toStep: OccurrenceStepEnum | null,
  occurrence: Occurrence | null,
): boolean => {
  if (toStep !== OccurrenceStepEnum.FOURTH_DIAGNOSIS) return false;
  if (occurrence?.tasNumber) return false;

  return true;
};
